import { render } from "./ModalTerm.vue?vue&type=template&id=509f91b5&scoped=true&ts=true"
import script from "./ModalTerm.vue?vue&type=script&lang=ts"
export * from "./ModalTerm.vue?vue&type=script&lang=ts"

import "./ModalTerm.vue?vue&type=style&index=0&id=509f91b5&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509f91b5"]])

export default __exports__